var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable, runInAction } from 'mobx';
import { useLayoutEffect } from 'react';
import { BaseService, Injectable } from './service.base';
export let TabsService = class TabsService extends BaseService {
    tabs = observable.array([]);
    tab;
    constructor() {
        super();
        makeObservable(this);
    }
    use = (items, value) => {
        useLayoutEffect(() => {
            if (!this.tabs.length || !this.tab) {
                runInAction(() => {
                    this.tabs.replace(items);
                    this.tab = value || items[0].value;
                });
            }
        }, [items, value]);
    };
    handleChange = (value) => {
        this.tab = value;
    };
};
__decorate([
    observable,
    __metadata("design:type", String)
], TabsService.prototype, "tab", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], TabsService.prototype, "handleChange", void 0);
TabsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], TabsService);
